//@ts-nocheck
import React from "react";
import { Card } from "antd";
import { tableColumnGenerator } from "../../../../libs/table";
import SimpleTableContainer from "../../../../Common/ClaimContainers/SimpleTableContainer";

class AuditReportSuperSummaryList extends React.Component {
  handleTableChange = (pagination: any, filters: any, sorter: any) => {
    let field = sorter.field;
    let options = {
      page: pagination.current,
      order: sorter.order === "ascend" ? "asc" : "desc",
      field: field,
    };
    this.props.handleTableChange({ options });
  };

  render() {
    const { data, loading } = this.props;
    let colTemplate = [
      {
        title: "Employee Name",
        dataIndex: "employeeName",
        sorter: false,
        width: "20%",
      },
      {
        title: "Payment Type",
        dataIndex: "paymentType",
        sorter: false,
        width: "20%",
      },
      {
        title: "Super Fund",
        dataIndex: "fundName",
        sorter: false,
        width: "20%",
      },
      {
        title: "Member Number",
        dataIndex: "memberNumber",
        sorter: false,
        width: "20%",
      },
      {
        title: "Amount",
        dataIndex: "amount",
        sorter: false,
        align: "right",
        dataType: "currency",
        width: "20%",
      },
    ];
    const column = tableColumnGenerator(colTemplate);
    return (
      <Card
        title={<div className="pt-3 pl-3">Super Payments Summary</div>}
        className="card-space-0"
      >
        <SimpleTableContainer
          columns={column}
          dataSource={data}
          loading={loading}
          onChange={this.handleTableChange}
          pagination={false}
          size="small"
          className="table-showing-total"
        />
      </Card>
    );
  }
}

export default AuditReportSuperSummaryList;
